import clsx from 'clsx';
import { Loan, TtDetails } from '../../generated/graphql';
import { useTtDetails } from '../../TtDetails';
import { LoansTableContainer, LoansTableContainerProps } from './LoansTableContainer';
import { LoanSumTableItem } from './LoanSumTableItem';

interface PersonalFinancialStatementLoansTableProps extends Pick<LoansTableContainerProps, 'tableTitleClassName'> {
  title: string;
  householdID: string;
  onItemClicked?: (a: { loan: Loan }) => void;
  loansSubset: keyof Pick<
    TtDetails['debtSummary'],
    'studentLoans' | 'businessLoans' | 'personalRealEstateLoans' | 'investmentRealEstateLoans' | 'otherDebt'
  >;
}

export function PersonalFinancialStatementLoansTable({
  title,
  loansSubset,
  householdID,
  onItemClicked,
  tableTitleClassName,
}: PersonalFinancialStatementLoansTableProps) {
  const { ttDetails, ttDetailsQuery } = useTtDetails({ householdID, includeDebtSummary: true });

  return (
    <LoansTableContainer
      title={title}
      onItemClicked={onItemClicked}
      isLoading={ttDetailsQuery.isLoading}
      loanArray={Array.from(ttDetails?.debtSummary[loansSubset] || [])}
      className="mb-[47px] last:mb-6"
      tableRowsContainerClassName="mt-[2px]"
      tableTitleClassName={clsx(tableTitleClassName, 'sticky top-[56px] z-[1] bg-darkMode-gray-background')}
    >
      {({ loan }) => (
        <LoanSumTableItem loan={loan} key={loan.id} onItemClicked={onItemClicked} className="focus:shadow-classic" />
      )}
    </LoansTableContainer>
  );
}
